import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw150kApi, QueryParams, VendorQualRow, ApproveItem } from '../../../services/pw150kApi';

export function usePW150KQuery() {
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(false);
  const [data, setData] = useState<VendorQualRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw150kApi.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '無須核准資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const approve = useCallback(async (items: ApproveItem[]) => {
    if (items.length === 0) {
      message.warning('請選擇要核准的項目');
      return;
    }
    setApproving(true);
    try {
      const resp = await pw150kApi.approve({ items });
      message.success(resp.message || '核准完成!');
      return resp;
    } catch {
      message.error('核准失敗，請稍後再試');
    } finally {
      setApproving(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, approving, data, queried, noData, runQuery, approve, reset };
}
